import { createSelector } from '@reduxjs/toolkit';
import { TeamPlayersNumber } from 'shared/types/team-players-number';
import { RootState } from 'store/store';

export const tourneysChampionshipStoreSelector = (state: RootState) => state.tourneys.championship;

export const championshipIsLoadingSelector = createSelector(tourneysChampionshipStoreSelector, (state) => state.isLoading);

export const championshipIsLoadedSelector = createSelector(tourneysChampionshipStoreSelector, (state) => state.isLoaded);

export const championshipTeamsIsLoadingSelector = (championshipId: number) =>
  createSelector(tourneysChampionshipStoreSelector, (state) => state.data?.byId[championshipId]?.teamsFlags.isLoading || false);

export const championshipTeamsIsLoadedSelector = (championshipId: number) =>
  createSelector(tourneysChampionshipStoreSelector, (state) => state.data?.byId[championshipId]?.teamsFlags.isLoaded || false);

export const championshipTeamsDataSelector = (championshipId: number) =>
  createSelector(tourneysChampionshipStoreSelector, (state) => state.data?.byId[championshipId]?.teams || []);

export const championshipISavingSelector = createSelector(tourneysChampionshipStoreSelector, (state) => state.isSaving);

export const championshipDataSelector = (championshipId: number) =>
  createSelector(tourneysChampionshipStoreSelector, (state) => state.data?.byId[championshipId]);

export const allIdsChampionshipsDataSelector = createSelector(tourneysChampionshipStoreSelector, (state) => state.data?.allIds);

export const championshipIsMatchSavingSelector = (championshipId: number) =>
  createSelector(tourneysChampionshipStoreSelector, (state) => state.data?.byId[championshipId]?.isMatchSaving || false);

export const championshipSymbolicTeamSelectedSelector = (championshipId: number) =>
  createSelector(tourneysChampionshipStoreSelector, (state) => state.data?.byId[championshipId]?.selectedSymbolicTeam || null);

export const championshipSymbolicTeamIsSavingSelector = (championshipId: number) =>
  createSelector(tourneysChampionshipStoreSelector, (state) => state.data?.byId[championshipId]?.isSymbolicTeamSaving || false);

export const championshipTeamPlayersNumberSelector = (championshipId: number) =>
  createSelector(
    tourneysChampionshipStoreSelector,
    (state) => state.data?.byId[championshipId]?.settings.teamPlayersNumber || TeamPlayersNumber.FIVE,
  );

export const championshipSettingsSelector = (championshipId: number) =>
  createSelector(tourneysChampionshipStoreSelector, (state) => state.data?.byId[championshipId]?.settings);

export const championshipIsDeletingSelector = createSelector(tourneysChampionshipStoreSelector, (state) => state.isDeleting);
